import { CoreIcon } from '../core-icon';
import sortSVG from '../../assets/icons/sort.svg';
import type { IconProps } from '../core-icon';

export const SortIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={sortSVG} {...props} />;
};
